import React, { JSX } from 'react';

import {
  Business,
  Event,
  ShoppingCart,
  Home,
  GroupWork,
  Category,
  Badge,
  Description,
  People,
  Error,
} from '@mui/icons-material';

type RouteType = 'General' | 'Sync' | 'Errors' | 'Hidden';

export interface AppRoute {
  id: string;
  path: string;
  label: string;
  icon?: JSX.Element;
  routeType: RouteType;
}

interface AppRoutes {
  [key: string]: AppRoute;
}

export const ROUTES: AppRoutes = {
  HOME: {
    id: 'home',
    path: '/',
    label: 'Home',
    icon: <Home />,
    routeType: 'General'
  },
  LOGIN: {
    id: 'login',
    path: '/login',
    label: 'Login',
    routeType: 'General'
  },
  DATA_ISSUES: {
    id: 'data_issues',
    path: '/issues/data',
    label: 'Data Issues',
    icon: <Error />,
    routeType: 'Errors'
  },
  FIX_BUYER_BY_PRODUCT: {
    id: 'fix_buyer_by_product',
    path: '/issues/fix_buyer_by_product',
    label: 'Fix Buyer By Product',
    icon: <Error />,
    routeType: 'Hidden'
  },
  FIX_PRODUCT_GROUP: {
    id: 'fix_product_group',
    path: '/issues/fix_product_group',
    label: 'Fix Product Group',
    icon: <Error />,
    routeType: 'Hidden'
  },
  FIX_CUSTOMER_GROUP: {
    id: 'fix_customer_group',
    path: '/issues/fix_customer_group',
    label: 'Fix Customer Group',
    icon: <Error />,
    routeType: 'Hidden'
  },
  BUYER_VENDOR: {
    id: 'buyer_vendor',
    path: '/sync/buyer-vendor',
    label: 'Buyer Vendor Data',
    icon: <Business />,
    routeType: 'Sync'
  },
  BUYER_BY_PRODUCT: {
    id: 'buyer_by_product',
    path: '/sync/buyer-by-product',
    label: 'Buyer By Product',
    icon: <Business />,
    routeType: 'Sync'
  },
  DATE_MAPPING: {
    id: 'date_mapping',
    path: '/sync/date-mapping',
    label: 'Date Mapping Data',
    icon: <Event />,
    routeType: 'Sync'
  },
  TRANSACTIONS: {
    id: 'transactions',
    path: '/uploads/transactions',
    label: 'Transaction Data',
    icon: <ShoppingCart />,
    routeType: 'Sync'
  },
  CUSTOMER_GROUP: {
    id: 'customer_group',
    path: '/sync/customer-group',
    label: 'Customer Group Data',
    icon: <GroupWork />,
    routeType: 'Sync'
  },
  PRODUCT_GROUP: {
    id: 'product_group',
    path: '/sync/product-group',
    label: 'Product Group Data',
    icon: <Category />,
    routeType: 'Sync'
  },
  SALES_REP_DEPARTMENT: {
    id: 'sales_rep_department',
    path: '/sync/sales-rep-department',
    label: 'Sales Rep Department Data',
    icon: <Badge />,
    routeType: 'Sync'
  },
  CREDIT_REPORT: {
    id: 'credit_report',
    path: '/sync/credit-report',
    label: 'Credit Report Data',
    icon: <Description />,
    routeType: 'Sync'
  },
  SALESMEN: {
    id: 'salesmen',
    path: '/sync/salesmen',
    label: 'Salesmen Data',
    icon: <People />,
    routeType: 'Sync'
  },
} as const;

const allRoutes: AppRoute[] = [];
for (const key in ROUTES) {
  allRoutes.push(ROUTES[key]);
}

export const SYNC_ROUTES = allRoutes.filter((route) => route.routeType === 'Sync');
export const GENERAL_ROUTES = allRoutes.filter((route) => route.routeType === 'General');
export const ERROR_ROUTES = allRoutes.filter((route) => route.routeType === 'Errors');
